import { render, staticRenderFns } from "./AssignWLCHelpModal.vue?vue&type=template&id=b1eb9a68&scoped=true&"
import script from "./AssignWLCHelpModal.vue?vue&type=script&lang=ts&"
export * from "./AssignWLCHelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./AssignWLCHelpModal.vue?vue&type=style&index=0&id=b1eb9a68&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1eb9a68",
  null
  
)

export default component.exports